import styled from "styled-components";

export const PopoverContainer = styled.div`
    
    width: 100%;
    max-width: 350px;

    @media (min-width: 720px) {
        max-width: 480px;
    }

    div.header{
        align-items: center;
        background: #F2F2F2;
        border: none;
        border-radius: 5px;
        box-shadow: 0px 1.52px 1.52px 0px rgba(0, 0, 0, 0.25);
        box-sizing: border-box;
        display: flex;
        margin-bottom: 10px;
        
        h2{
            color: #333;
            flex: 16;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            gap: 10px;
            line-height: normal;
            text-align: center;

            @media (min-width: 720px) {
                font-size: 18px;
            }
            @media (orientation: landscape) and (max-width: 1080px){
                font-size: 16px;
            }
            
            span{
                background: #006560;
                border-radius: 5px;
                color: #FFF;
                font-size: 12px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
                margin: 0 10px;
                padding:  6px 10px;
                text-align: center;

                @media (min-width: 720px) {
                    font-size: 16px;
                    padding:  6px 12px;
                }
                @media (orientation: landscape) and (max-width: 1080px){
                    font-size: 14px;
                    padding:  6px 12px;
                }
            }
        }
    }

    p{
        color: #333;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-align: justify;

        @media (min-width: 720px) {
            font-size: 14px;
        }
        @media (orientation: landscape) and (max-width: 1080px){
            font-size: 14px;
        }
    }

    div.container{
        display: flex;
        flex-direction: row;
        gap: 30px;
        justify-content: center;
        margin-top: 10px;
    }
`;